import { render, staticRenderFns } from "./CoFundingInfo.vue?vue&type=template&id=3c8b96d3"
import script from "./CoFundingInfo.vue?vue&type=script&lang=ts"
export * from "./CoFundingInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports